/* eslint-disable react/prop-types */
import React from 'react';

const sendInvitationOperationTypesWhitelist = ['mot', 'c&d'];

const sendInvitationOperationSKUWhitelist = [
  'fixter-driver-fee',
  'garage-driver-fee',
  'free-timing-belt-replacement-check',
  'safety-check',
  'brakes-check',
  'exhaust-check',
  'fluid-check',
  'winter-health-check',
  'air-con-check',
  'timing-belt-check',
  'tyre-check',
  'battery-check',
  'steering-check',
  'suspension-check',
  'mot-premium',
  'full-service',
  'interim-service',
  'discount',
  'credit',
  'coupon',
  'mot-bonus',
  'premium-oil',
  'front-brake-pads-replace',
  'front-brake-disc-replace',
  'major-service',
  'rear-brake-pads-replace',
  'rear-brake-disc-without-epb-replace',
  'revision-simple',
  'revision-complete',
  'changement-courroie-distribution',
  'changement-plaquettes-disque-frein-avant',
  'changement-plaquettes-disque-frein-arriere-avec-epb',
  'changement-plaquettes-frein-avant',
];

const hasOnlyAllowedOperations = (lineItems) => {
  const notAllowedOperations = lineItems.filter(
    (op) =>
      !(
        sendInvitationOperationTypesWhitelist.includes(op.type) ||
        sendInvitationOperationSKUWhitelist.includes(op.sku)
      )
  );

  return notAllowedOperations.length === 0;
};

const PricingSection = ({ booking }) => {
  if (hasOnlyAllowedOperations(booking?.quote?.lineItems || [])) return null;

  return <div className="allocation-card-pricing">£ Pricing</div>;
};

export default PricingSection;
